import { useTranslation } from 'react-i18next'

import { Truck } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CarrierInfo = ({ name, serviceName }) => {
  const { t } = useTranslation()

  if (!name && !serviceName) return null

  return (
    <Styles.Container>
      <div>
        <Truck size={24} />
        <Text type="bodyMBold">{t('Servicio de logística')}:</Text>
        {name} ({serviceName})
      </div>
      <small>{t('Conexión con transportista activada. Las etiquetas de envío se generarán automáticamente.')}</small>
    </Styles.Container>
  )
}

export default CarrierInfo
